$(document).ready(function(){
  $('.banner-slider-area').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
     loop:true,
    speed: 3000,
    paginationSpeed : 400,
    autoplay: false,
    dots: false,
    appendArrows: '.banner-slider-area-nav', // custom arrow container
    prevArrow: "<button type='button' class='slick-prev'><img src='https://cdn.shopify.com/s/files/1/0676/1509/6918/files/prev-arrow-1.png?v=1758082264' alt='Previous'></button>",
    nextArrow: "<button type='button' class='slick-next'><img src='https://cdn.shopify.com/s/files/1/0676/1509/6918/files/next-arrow-1.png?v=1758082264' alt='Next'></button>",
    responsive: [
      {
        breakpoint: 1100,
        settings: { slidesToShow: 1 }
      },
      {
        breakpoint: 1000,
        settings: { slidesToShow: 1 }
      },
      {
        breakpoint: 700,
        settings: { slidesToShow: 1 }
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1}
      }
    ]
  });
    // Service slider Js
function initServicesSlider(container = document) {

  $(container).find('.services-slider').each(function () {

    const $slider = $(this);

    if ($slider.hasClass('slick-initialized')) {
      return;
    }

    const $section = $slider.closest('.services-slider-section');

    $slider.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: true,
      centerMode: true,
      centerPadding: '0px',
      arrows: true,
      prevArrow: $section.find('.services-prev'),
      nextArrow: $section.find('.services-next'),

      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 4,
            centerMode: true
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            centerMode: true
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            centerMode: true
          }
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
            centerMode: true
          }
        }
      ]
    });

    toggleSliderArrows($slider, $section);
  });

}

function toggleSliderArrows($slider, $section) {

  const slick = $slider.slick('getSlick');

  let slidesToShow = slick.options.slidesToShow;

  if (slick.slideCount <= slidesToShow) {
    $section.find('.services-slider-nav').hide();
  } else {
    $section.find('.services-slider-nav').show();
  }
}

$(document).ready(function () {
  initServicesSlider();
});

document.addEventListener('shopify:section:load', function (event) {

  setTimeout(function () {
    initServicesSlider(event.target);
  }, 100);

});

document.addEventListener('shopify:section:select', function (event) {

  setTimeout(function () {
    initServicesSlider(event.target);
  }, 100);

});

document.addEventListener('shopify:block:select', function (event) {

  setTimeout(function () {
    initServicesSlider(event.target.closest('.shopify-section'));
  }, 100);

});

// product slider
$('.product-slider').slick({
  dots:false,
  infinite: true,
  autoplay: false,
  autoplaySpeed: 3000,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  prevArrow: $('.custom-prev'),
  nextArrow: $('.custom-next'),
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    
  ]
});

});

document.addEventListener("DOMContentLoaded", () => {
  const slider = document.querySelector(".thumbnail-slider .thumbnail-list");
  if (!slider) return;

  // Hide arrows
  document.querySelectorAll(".thumbnail-slider .slider-button").forEach(btn => {
    btn.style.display = "none";
  });

  // Enable horizontal scrolling
  slider.style.overflowX = "auto";
  slider.style.scrollBehavior = "smooth";
  slider.style.scrollbarWidth = "none";
  slider.style.msOverflowStyle = "none";
  slider.style.cursor = "grab";

  // Mouse wheel -> horizontal scroll
  slider.addEventListener("wheel", function(e) {
    if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
      e.preventDefault();
      slider.scrollLeft += e.deltaY;
    }
  }, { passive: false });

  // Drag Scroll
  let isDown = false;
  let startX;
  let scrollLeft;

  slider.addEventListener("mousedown", (e) => {
    isDown = true;
    startX = e.pageX;
    scrollLeft = slider.scrollLeft;
    slider.style.cursor = "grabbing";
  });

  document.addEventListener("mouseup", () => {
    isDown = false;
    slider.style.cursor = "grab";
  });

  slider.addEventListener("mousemove", (e) => {
    if (!isDown) return;
    e.preventDefault();
    slider.scrollLeft = scrollLeft - (e.pageX - startX);
  });
});

//Form CSS
  window.formStyles = window.formStyles || new Map();

  window.formStyles.set('my-custom-overrides', `
    /* Style the main form container */
    form {
      border: 2px solid #000000 !important;
      box-shadow: none !important;
      border-radius: 8px !important;
    }

/* Style the text elements */
    h1, h2, h3, p {
      font-family: "YourCustomFont", sans-serif !important;
      color: #333333 !important;
    }

/* Style input fields */

._formFieldset_cit2d_82 legend {
    height: 24px!important;
    width: 100%;
    margin-bottom: 10px !important;
    max-height: initial!important;
}
._formFieldset_cit2d_82 input:focus-visible, ._formFieldset_cit2d_82 select:focus-visible, ._formFieldset_cit2d_82 textarea:focus-visible, ._selectToggle_12thd_25:focus-visible, legend:focus-visible {
    box-shadow: none!important;
    border: 1px solid #fff!important;
}
._formFieldset_cit2d_82 input, ._formFieldset_cit2d_82 select, ._formFieldset_cit2d_82 textarea, ._selectToggle_12thd_25, legend {
    color: rgba(255, 255, 255, 1)!important;
    font-family: SF Pro Display!important;
    font-weight: 500!important;
    line-height: 1.5em!important;
    letter-spacing: 0%!important;
    background: rgba(255, 255, 255, 0.1)!important;
    padding: 19px 40px!important;
    font-size: 16px!important;
    border: 1px solid transparent!important;
    border-radius: 0px!important;
    height: 63px;
    max-height: initial!important;
}
._formFieldset_cit2d_82 ._formFieldContainer_1mxsl_5:has(textarea)::before{
    display:none!important;
    }
._formFieldset_cit2d_82 label, ._checkboxFieldSet_1hja3_3 label span {
    font-family: SF Pro Display!important;
    font-weight: 500!important;
    font-size: 16px!important;
    line-height: 1.5em!important;
    letter-spacing: 0%!important;
    color: #fff!important;
    left: 40px!important;
}
._formFieldset_cit2d_82 button[aria-controls="country-selector-dropdown"] {
    padding: 15px!important;
}
._formFieldset_cit2d_82 label[for="label-phone_number"] {
    transform: translateY(calc(1em * -0.9))
    scale(0.85)!important;
}
 section._formHeader_cit2d_24 {
    display: none!important;
}
 section[aria-label="Get a Quote"],  section[aria-label="BECOME A PARTNER"] {
    max-width: 971px!important;
}
section[aria-label="Get a Quote"] textarea {
    height: 187px!important;
    backdrop-filter: blur(13px)!important;
}
section[aria-label="BECOME A PARTNER"] textarea{
     height: 118px!important;
    backdrop-filter: blur(13px)!important;
}
section[aria-label="Get a Quote"] form, section[aria-label="BECOME A PARTNER"] form {
    gap: 30px!important;
}
 section[aria-label="Get a Quote"] p, section[aria-label="BECOME A PARTNER"] p{
color:#fff!important;
}
._formFieldset_cit2d_82 p._label_12thd_10._textBody_2aowh_10 {
    color: #fff!important;
    font-family: SF Pro Display!important;
    font-weight: 500!important;
    font-size: 16px!important;
    line-height: 1.5em!important;
    letter-spacing: 0%!important;
}
 section[aria-label="Get a Quote"] svg path, section[aria-label="BECOME A PARTNER"] svg path{
    fill:#fff!important;
}
    /* Style the submit button */

._formFieldset_cit2d_82 button[type="submit"] {
    display: inline-flex!important;
    align-items: center!important;
    gap: 13px!important;
    background: #df6a26!important;
    color: #fff!important;
    text-decoration: none!important;
    padding: 21px 26px!important;
    font-size: 20px!important;
    font-weight: 700!important;
    text-transform: uppercase!important;
    transition: .3s!important;
    border-radius: 0!important;
    font-style: italic!important;
}
._formFieldset_cit2d_82 button[type="submit"]:hover {
    background: #fff!important;
    color: #df6a26!important;
}
._formFieldset_cit2d_82 button[type="submit"]:after {
    content: "";
    width: 25.5px;
    height: 17.82px;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='26' height='18' viewBox='0 0 26 18' fill='none'%3E %3Cpath d='M2.83474 0L0 2.63225L6.4794 8.90917L0.202481 15.1861L2.83474 17.8183L12.1489 8.90917L2.83474 0Z' fill='white' fill-opacity='0.5'/%3E %3Cpath opacity='0.8' d='M9.55819 0L6.72345 2.63225L13.2028 8.90917L6.92593 15.1861L9.55819 17.8183L18.8723 8.90917L9.55819 0Z' fill='white'/%3E %3Cpath d='M16.1859 0L13.3511 2.63225L19.8305 8.90917L13.5536 15.1861L16.1859 17.8183L25.5 8.90917L16.1859 0Z' fill='white'/%3E %3C/svg%3E");
    display: block;
    position: unset;
    border: unset;
    outline: unset;
    box-shadow: unset;
}
._formFieldset_cit2d_82 button[type="submit"]:hover:after {
    filter: brightness(0) saturate(100%) invert(53%) sepia(76%) saturate(1896%) hue-rotate(346deg) brightness(91%) contrast(89%);
    box-shadow: unset;
}
form input[type="checkbox"] {
    -webkit-appearance: none !important;
    appearance: none !important;
    width: 22px !important;
    height: 22px !important;
    border: 1px solid #fff!important;
    background: transparent !important;
    position: relative !important;
    cursor: pointer !important;
    margin: 0 12px 0 0 !important;
    padding: 10px!important;
    min-width: 22px!important;
}

form input[type="checkbox"]:checked{
    background: #f58220 !important;
    border-color: #f58220 !important;
}
._checkboxField_1hja3_3 {
    grid-template-columns: 1.4em minmax(0, 1fr)!important;
    gap: 19px!important;
}
._checkboxFieldSet_1hja3_3 ._verticalLayout_1hja3_8 {
    row-gap: 22px;
}
form input[type="checkbox"]:checked::before{
    content: "";
    position: absolute;
    left: 6px;
    top: 1px;
    width: 6px;
    height: 11px;
    border: solid #fff;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
}
._formDisclaimer_cit2d_38 p {
    display: none!important;
}
    /* When input has value (floating label) */
._formFieldContainer_1mxsl_5:has(input:not(:placeholder-shown)) ._formInputFieldLabel_1mxsl_38,
._formFieldContainer_1mxsl_5:has(input:focus) ._formInputFieldLabel_1mxsl_38 {
    font-size: 12px !important;
}
@media only screen and (max-width: 1200px) {

    section[aria-label="Get a Quote"] form, section[aria-label="BECOME A PARTNER"] form {
    gap: 20px!important;
}
    section[aria-label="Get a Quote"], section[aria-label="BECOME A PARTNER"] {
    max-width: 100%!important;
}
section[aria-label="Get a Quote"] textarea {
    height: 127px !important;
}
}
@media only screen and (max-width: 980px) {
._formFieldset_cit2d_82 label, ._checkboxFieldSet_1hja3_3 label span {
    left: 20px!important;
    top: 15px!important;
}
._formFieldset_cit2d_82 input, ._formFieldset_cit2d_82 select, ._formFieldset_cit2d_82 textarea, ._selectToggle_12thd_25, legend {
    padding: 15px 20px!important;
        height: 55px;
}
._formFieldset_cit2d_82 legend {
    height: initial!important;
}
}
@media only screen and (max-width: 767px) {
section[aria-label="Get a Quote"] form, section[aria-label="BECOME A PARTNER"] form {
    gap: 15px!important;
}
._formFieldset_cit2d_82 button[type="submit"] {
    padding: 15px 18px!important;
    font-size: 16px!important;
}
  `);


